import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/shared/components/Component";
import SeasonsPage from "./seasonsPage/SeasonsPage";
import withAxios from "src/shared/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { IProps, ISeasonsProps, ISeasonsState } from "./types";
import { styles } from "./styles";

export default withSchoolContext<ISeasonsProps>(
  withStyles(styles)(
    withAxios(
      class extends Component<IProps, ISeasonsState> {
        public readonly state = this.buildState({});

        public render() {
          const {
            saved,
            saving,
            school,
            schoolSeasonActive,
            sports,
            seasons,
            loadingSeasonsResponse,
            loadSeasons,
            setSeason,
            seasonsChange,
          } = this.props;
          return (
            <SeasonsPage
              saved={saved}
              saving={saving}
              schoolName={school.name}
              schoolSeasonActive={schoolSeasonActive}
              schoolId={school.id}
              seasons={seasons}
              loadingSeasonsResponse={loadingSeasonsResponse}
              loadSeasons={loadSeasons}
              setSeason={setSeason}
              seasonsChange={seasonsChange}
              sports={sports}
              school={school}
            />
          );
        }
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/Seasons.tsx